import RolesUtil from 'permissions/utils/roles';
const SectionReviewPermissions = {
  canReviewSection: (stateData, projectID) =>
    RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHavePreparerReviewerRoleForProject(
      stateData,
      projectID,
    ) ||
    RolesUtil.doesUserHaveObserverRoleForProject(stateData, projectID),

  canAssignSection: (stateData, projectID) =>
    RolesUtil.doesUserHavePPMDRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData, projectID) ||
    RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData, projectID),
};

export default SectionReviewPermissions;
